<template>
  <b-modal id="BSReviewQuestionModalID" @show="showMe" centered size="lg" >
    <template #modal-header>
      <h2 class="modal-title" v-if="question_id==0">{{ $t("buttons.adquestion") }}</h2>
      <h2 v-else>{{question}}</h2>
    </template>

    <form class="form">
      <div class="form-row"  v-if="current_user && current_user.role == 'admin'">
        <div class="col-3">
          <label for=""> {{ $t("labels.question") }}</label>
        </div>
        <div class="col"  >
          <b-input-group>
            <b-form-textarea size="sm" rows="4"
              class="form-control" v-model="question" />
          </b-input-group>          
        </div>
      </div>
      <div class="form-row"  v-if="current_user && current_user.role == 'admin'">
        <div class="col-3">
          <label for=""> {{ $t("labels.questiontype") }}</label>
        </div>
        <div class="col"  >
              <b-form-select v-model="question_type" class="form-control">
                <option value="1"> {{ $t("labels.questiontype1") }}</option>
                <option value="2"> {{ $t("labels.questiontype2") }}</option>
                <option value="3">{{ $t("labels.questiontype3") }}</option>
              </b-form-select>
        </div>
      </div>   
    </form>

    <template #modal-footer>
      <div @click="saveData" class="btn btn-primary">
       {{ $t('buttons.saveandclose') }}
      </div>
    </template>
  </b-modal>
</template>


<script>
import { mapGetters, mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'invoice-data-modal',
  data() {
    return {
      question:"",
      question_type:1

    }
  },
  props: {
    question_id: Number
  },
  computed: {

    ...mapState([
      'invoiceextra',
      'current_user',

    ]),
    ...mapGetters([
    'append_data_string',

    ]),

  },
  mounted(){
    this.showMe();
  },
  methods: {
    saveData(){
        axios.post('/api/reviewquestion/'+this.question_id, {id:this.question_id,question_type:this.question_type, question:this.question})
        .then(async () => {
          this.$emit('refresh', null)

          this.$bvModal.hide('BSReviewQuestionModalID')
        })

    },
    showMe(){
      axios.get("/api/reviewquestions/all")
        .then((response) => {
          this.reviewquestions =  response.data
          console.log(">>>>>showMeshowMe>>>>", this.reviewquestions)
          if(this.question_id!=0){
            this.question_type = this.reviewquestions.filter(r=>r.id==this.question_id)[0].question_type
            this.question = this.reviewquestions.filter(r=>r.id==this.question_id)[0].question
          }
        })
        .catch(() => {
        });
    },
    close_modal() {
      this.$bvModal.hide('BSReviewQuestionModalID')
    },
  },
}    
</script>
